/**
 * DOMException polyfill for Hermes
 * ----
 * Hermes does not expose `DOMException` as a global. Packages such as
 * `livekit-client` evaluate `class … extends DOMException` at module load,
 * which crashes native startup with:
 *   ReferenceError: Property 'DOMException' doesn't exist
 *
 * Import this module before any LiveKit / WebRTC imports (first line of App.jsx).
 * Play Console 16 KB Lab crashes that look like "Google Play is enabled" after
 * splash were this JS failure on a 16 KB emulator — not an ELF alignment issue.
 */

type DOMExceptionConstructor = new (message?: string, name?: string) => Error;

if (typeof (globalThis as { DOMException?: DOMExceptionConstructor }).DOMException === 'undefined') {
  class DOMExceptionPolyfill extends Error {
    constructor(message = '', name = 'Error') {
      super(message);
      this.name = name;
    }
  }

  (globalThis as { DOMException?: DOMExceptionConstructor }).DOMException = DOMExceptionPolyfill;

  // Hermes / RN also expose `global` in some contexts; keep them in sync.
  if (typeof global !== 'undefined') {
    (global as { DOMException?: DOMExceptionConstructor }).DOMException = DOMExceptionPolyfill;
  }
}
